import { isAxiosError } from 'axios';

function isTimeoutOrCancelError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const err = error as { name?: string; code?: string; message?: string };
  if (err.name === 'AbortError' || err.name === 'CanceledError' || err.name === 'TimeoutError') {
    return true;
  }
  if (err.code === 'ECONNABORTED' || err.code === 'ERR_CANCELED') return true;
  if (typeof err.message === 'string' && /timeout|aborted|canceled/i.test(err.message)) {
    return true;
  }
  return false;
}

/**
 * Shared learner curriculum GET: one retry owner for transient upstream/network failures.
 * Do not retry auth failures or client errors.
 */
export function shouldRetryLearnerCurriculumQuery(failureCount: number, error: Error): boolean {
  if (failureCount >= 1) return false;
  if (isTimeoutOrCancelError(error)) return false;
  if (isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 401 || status === 403 || status === 404) return false;
    if (status === 502 || status === 503 || status === 504) return true;
    if (error.response) return false;
    return true;
  }
  return false;
}
